export default __webpack_public_path__ + "static/media/cloud_rockets@3x.e3753579.png";